import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import SingleColumnLayout from '../../components/Layouts/SingleColumnLayout';
import Heading from './components/Heading';
import ButtonControls from './components/ButtonControls';
import MainRegion from './components/MainRegion';
import { CreateExpenseReportProvider } from './utils/CreateExpenseReportContext';
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
function CreateExpenseReport() {
    return (_jsx(CreateExpenseReportProvider, { children: _jsxs(SingleColumnLayout, { children: [_jsx(Heading, {}), _jsx(MainRegion, {}), _jsx(ButtonControls, {})] }) }));
}
export default CreateExpenseReport;
